module.exports = __webpack_public_path__ + "img/14.f0663a42.jpg";